// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import DryRunHintController from "./dry_run_hint_controller"
application.register("dry-run-hint", DryRunHintController)

import SearchFormController from "./search_form_controller"
application.register("search-form", SearchFormController)

import SelectNavigationController from "./select_navigation_controller"
application.register("select-navigation", SelectNavigationController)

import LocalTimeController from "./local_time_controller"
application.register("local-time", LocalTimeController)
